import * as Models from "../../../Models";
import * as UserManagementApiClient from './UserManagementApiClientService';
import * as Services from "../../../Services";


    export interface IPartnerRetrievalService {
        getPartners: (excludeUsersGroups?: boolean) => ng.IPromise<Models.PartnerModel.IPartnerModel[]>;
        getPartner(partnerCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel>;
        getPartnerSettings(partnerCode: string): ng.IPromise<Models.PartnerSettingsModel.IPartnerSettings>;
        getPartnerRelationships(stateCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel[]>
        getPartnerRelationshipsByPartner(partnerCode: string, stateCode: string): ng.IPromise<Models.PartnerModel.IPartnerModel[]>
        getPartnersForUserManagement(): ng.IPromise<Models.PartnerModel.IPartnerModel[]>
    }

    export class PartnerRetrievalService implements IPartnerRetrievalService {
        public static $inject = [
            'UserManagementApiClientService',
            'PartnerSettingsApiClientService'
        ];

        constructor(private userManagementApiClientService: UserManagementApiClient.IUserManagementApiClientService,
            private partnerSettingsApiClientService: Services.PartnerSettingsApiClientService.IPartnerSettingsApiClientService
        ) {}

        public getPartners = (excludeUsersGroups?: boolean) => {
            return this.userManagementApiClientService.getPartners(excludeUsersGroups || false);
        }

        public getPartner = (partnerCode: string) => {
            return this.userManagementApiClientService.getPartnerByCode(partnerCode);
        }

        public getPartnerSettings = (partnerCode: string) => {
            return this.partnerSettingsApiClientService.getPartnerSettings(partnerCode);
        }

        public getPartnerRelationships = (stateCode: string) => {
            return this.partnerSettingsApiClientService.getPartnerRelationships(stateCode);
        }

        public getPartnerRelationshipsByPartner = (partnerCode: string, stateCode: string) => {
            return this.partnerSettingsApiClientService.getPartnerRelationshipsByPartner(partnerCode, stateCode);
        }

        public getPartnersForUserManagement = () => {
            return this.partnerSettingsApiClientService.getPartnersForUserManagement();
        }
    }